
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is a VPN and why do I need one?',
      answer: 'A VPN (Virtual Private Network) creates a secure, encrypted connection between your device and the internet. It protects your privacy, secures your data from hackers, and allows you to access content without restrictions. In today\'s digital age, a VPN is essential for protecting your personal information and maintaining online privacy.'
    },
    {
      question: 'How does LACOJEC VPN protect my privacy?',
      answer: 'Our VPN uses military-grade AES-256 encryption to secure your internet connection. We maintain a strict zero-log policy, meaning we never track, collect, or share your browsing data. Your IP address is masked, making your online activities completely anonymous and untraceable.'
    },
    {
      question: 'Will using a VPN slow down my internet connection?',
      answer: 'While encryption does add a small overhead, our optimized server infrastructure ensures minimal impact on your connection speed. Most users experience no noticeable difference in their browsing, streaming, or downloading speeds. In some cases, a VPN can even improve speeds by bypassing ISP throttling.'
    },
    {
      question: 'Can I use the VPN on multiple devices?',
      answer: 'Yes! Our VPN service supports multiple devices simultaneously. You can protect your smartphone, tablet, laptop, and desktop computer all at the same time with a single account, ensuring comprehensive security across all your devices.'
    },
    {
      question: 'Is it legal to use a VPN?',
      answer: 'Yes, using a VPN is legal in most countries, including Colombia and the United States. VPNs are legitimate tools used by individuals and businesses worldwide to protect their privacy and secure their internet connections. However, we encourage users to comply with local laws and terms of service of websites they visit.'
    },
    {
      question: 'How do I get started with LACOJEC VPN?',
      answer: 'Getting started is simple! Contact us through our contact form or reach out directly via phone or email. Our team will guide you through the setup process and help you get connected to our secure VPN network in minutes.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-thin text-gray-900 mb-6">
            Frequently Asked Questions
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600">
            Find answers to common questions about our VPN service
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h4 className="text-lg font-semibold text-gray-900 text-left">
                  {faq.question}
                </h4>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-teal-500 transition-transform`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-5 bg-gray-50 border-t border-gray-200">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
